(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('AccessLevelService', AccessLevelService)

    /** @ngInject */
    function AccessLevelService(HttpService) {
        const AccessLevelService = {
            get: get,
            getAll: getAll,
            getByParameters: getByParameters
        }

        return AccessLevelService;

        function get(id) {
            return HttpService.get(`/access-levels/${id}`);
        }

        function getAll() {
            return HttpService.get('/access-levels/all');
        }

        function getByParameters(params) {
            return HttpService.get('/access-levels', {
                params
            });
        }
    }
}());